/*
 * Developed by HuMingZhi on 12/24/18 8:46 PM
 * Copyright (c) 2018. All right reserved.
 */
import { cdn } from '../config/cdn';
import { isWebpSupport } from '../detectors/isWebpSupport';
import { log } from './log';
export var getCDNDomain = (function (cdns) {
    var cdnIndex = 0;
    return function () { return cdns[cdnIndex++ % cdns.length]; };
})(cdn);
/**
 * @param {string} url 原始图片地址
 * @param {number} quality 压缩比
 * @param {string} size 图片的尺寸
 * @param {boolean} supportWebp 是否支持webp
 * @return {string} 获取压缩之后的图片
 */
export var getClientImage = function (url, quality, size, supportWebp) {
    if (quality === void 0) { quality = 50; }
    if (size === void 0) { size = '360x360'; }
    if (!url) {
        log('error', 'image url missing', 'getClientImage.ts', 'getClientImage');
    }
    if (quality <= 0 || quality > 100) {
        log('error', 'quality between 1 to 100 required', 'getClientImage.ts', 'getClientImage');
    }
    var webp = typeof supportWebp === 'boolean'
        ? supportWebp
        : isWebpSupport('isWebpSupport');
    var suffix = "~" + size + "_q" + quality + "." + (webp ? 'webp' : 'jpeg');
    var mat = url.match(/p3a.pstatp.com\/(large|origin)\/(.*)/);
    if (mat && mat[1] && mat[2]) {
        if (mat[2].indexOf('temai') === 0) {
            return "https://" + getCDNDomain() + "/img/" + mat[2] + suffix;
        }
        return "https://" + getCDNDomain() + "/img/mosaic-legacy/" + mat[2] + suffix;
    }
    if (url.indexOf('ttcdn-tos.pstatp.com/obj/temai/') > 0) {
        return (url.replace('ttcdn-tos.pstatp.com/obj/temai/', 'ttcdn-tos.pstatp.com/img/temai/') + suffix);
    }
    mat = url.match(/ttcdn-tos\.pstatp\.com\/img\/temai\/(.*)~/);
    if (mat && mat[1]) {
        return "https://" + getCDNDomain() + "/img/temai/" + mat[1] + suffix;
    }
    if (webp &&
        /ttcdn-tos\.pstatp\.com\/img\/mosaic-legacy\/.+\.image$/.test(url)) {
        return url.slice(0, -5) + "webp";
    }
    return url;
};
/**
 * @param {string} tosKey 原始图片tos的key
 * @param {number} quality 压缩比
 * @param {string} size 图片的尺寸
 * @param {boolean} supportWebp 是否支持webp
 * @return {string} 获取压缩之后的图片
 */
export var getClientImageWithKey = function (tosKey, quality, size, supportWebp) {
    if (quality === void 0) { quality = 50; }
    if (size === void 0) { size = '360x360'; }
    if (!tosKey) {
        log('error', 'image key missing', 'getClientImage.ts', 'getClientImageWithKey');
    }
    if (quality <= 0 || quality > 100) {
        log('error', 'quality between 1 to 100 required', 'getClientImage.ts', 'getClientImageWithKey');
    }
    var webp = typeof supportWebp === 'boolean'
        ? supportWebp
        : isWebpSupport('isWebpSupport');
    var suffix = "~" + size + "_q" + quality + "." + (webp ? 'webp' : 'jpeg');
    var hasBucket = tosKey.indexOf('/') !== -1;
    return "https://" + getCDNDomain() + "/img/" + (hasBucket ? '' : 'temai/') + tosKey + suffix;
};
